import React, {useEffect} from 'react';
import './App.css'
import OurWorkFeatured from './components/work/ourwork-featured'
import OurWorkServe from './components/work/ourwork-whoweserve'
import OurWorkCaseStudies from './components/work/ourwork-casestudies'
import OurWorkWhyPantheon from './components/work/ourwork-whypantheon'
import OurWorkPartnering from './components/work/ourwork-partnering'
import AOS from "aos";
import "aos/dist/aos.css";

function Work() {
  useEffect(() => {
    AOS.init({duration: 1000});
    window.scrollTo(0, 0);
  }, []);
  return (
   <>
   <OurWorkFeatured />
   <div data-aos="fade-up"><OurWorkServe /></div>
   <div data-aos="fade-up"><OurWorkCaseStudies /></div>
   <div data-aos="fade-up"><OurWorkWhyPantheon /></div>
   <div data-aos="fade-up"><OurWorkPartnering /></div>
   </>
  );
};

export default Work;
